import { apiUrl } from '../config';
import { fetch, handleApiError, upload } from '../utils/http';

function fetchSupportItemsStart() {
    return {
        type : 'FETCH_SUPPORT_ITEMS_START'
    }
}

function fetchSupportItemsSuccess(data) {
    return {
        type : 'FETCH_SUPPORT_ITEMS_SUCCESS',
        data
    }
}

function fetchSupportItemsFailure(error) {
    return {
        type : 'FETCH_SUPPORT_ITEMS_FAILURE',
        error
    }
}


export function fetchSupportItems() {
    return function(dispatch) {
        dispatch(fetchSupportItemsStart());
        const url = `${apiUrl()}/sale-support`;
        fetch(url)
            .then(response => response.json())
            .then(data => dispatch(fetchSupportItemsSuccess(data)))
            .catch(err => handleApiError(err, dispatch, fetchSupportItemsFailure));
    }
}

function deleteSupportItemStart() {
    return {
        type : 'DELETE_SUPPORT_ITEM_START'
    }
}

function deleteSupportItemSuccess(item) {
    return {
        type : 'DELETE_SUPPORT_ITEM_SUCCESS',
        item
    }
}

function deleteSupportItemFailure(error) {
    return {
        type : 'DELETE_SUPPORT_ITEM_FAILURE',
        error
    }
}


export function deleteSupportItem(item) {
    return function(dispatch) {
        dispatch(deleteSupportItemStart());
        const url = `${apiUrl()}/sale-support/${item.id}`;
        fetch(url, {
            method : 'DELETE'
        })
            .then(response => response.json())
            .then(data => dispatch(deleteSupportItemSuccess(data)))
            .catch(err => handleApiError(err, dispatch, deleteSupportItemFailure));
    }
}

function storeSupportItemStart(xhr, editedItem) {
    return {
        type : 'STORE_SUPPORT_ITEM_START',
        xhr,
        editedItem,
    };
}

function storeSupportItemProgress(progress) {
    return {
        type : 'STORE_SUPPORT_ITEM_PROGRESS',
        progress,
    };
}

function storeSupportItemCancel() {
    return {
        type : 'STORE_SUPPORT_ITEM_CANCEL'
    };
}

function storeSupportItemSuccess(item) {
    return {
        type : 'STORE_SUPPORT_ITEM_SUCCESS',
        item
    };
}

function storeSupportItemFailure() {
    return {
        type : 'STORE_SUPPORT_ITEM_FAILURE'
    };
}


export function storeSupportItem(data) {
    const url = `${apiUrl()}/sale-support/${data.item ? data.item.id : ''}`;
    const formData = {...data};
    delete formData.file;
    delete formData.cover;
    delete formData.item;
    return function(dispatch) {
        const xhr = upload(
            url,
            {
                'file' : data.file,
                'cover' : data.cover,
            },
            (evt) => {
                const newItem = JSON.parse(xhr.responseText);
                dispatch(storeSupportItemSuccess(newItem));
            },
            (evt) => {
                dispatch(storeSupportItemFailure(evt));
            },
            (evt) => {
                dispatch(storeSupportItemProgress(100 * evt.loaded /evt.total));
            },
            (evt) => {
                dispatch(storeSupportItemCancel());
            },
            formData,
            {
                method : data.item ? 'PUT' : 'POST'
            }
        );
        dispatch(storeSupportItemStart(xhr, data.item));
        
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/support.js
 **/